import { Util } from '../utils';
import { makeApiCall } from './xhr';
import { AttachedDocumentTypeMock } from './mocks';

const USE_MOCK = process.env.REACT_APP_MOCK === 'true';
const BASE_URL = `${process.env.REACT_APP_API_URL}/AttachedDocumentType`;

export const getAllAttachedDocumentTypes = async (params) => {
    if (USE_MOCK) {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve(AttachedDocumentTypeMock.GET_ALL_DOCUMENT_TYPES);
            }, 1000)
        );
    }

    return makeApiCall(`${BASE_URL}/GetAllAttachedDocumentTypes?${Util.objectToQueryString(params)}`, 'get');
}

export const getAllAttachedDocumentTypesByVendor = async (params) => {
    if (USE_MOCK) {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve(AttachedDocumentTypeMock.GET_ALL_DOCUMENT_TYPES);
            }, 1000)
        );
    }

    return makeApiCall(`${BASE_URL}/GetAllAttachedDocumentTypesByVendor?${Util.objectToQueryString(params)}`, 'get');
}

export const createAttachedDocumentType = async (payload) => {
    if (USE_MOCK) {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve();
            }, 1000)
        );
    }

    return makeApiCall(`${BASE_URL}/CreateAttachedDocumentType`, 'post', payload);
}

export const updateAttachedDocumentType = async (payload) => {
    if (USE_MOCK) {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve();
            }, 1000)
        );
    }

    return makeApiCall(`${BASE_URL}/UpdateAttachedDocumentType`, 'post', payload);
}